import { useState, forwardRef } from "react";
import { Input } from "../../components/ui/input";
import { Eye, EyeSlash } from "@phosphor-icons/react";

/**
 * Password input with show/hide toggle.
 * Forwards refs and accepts all native input props.
 */
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", testId = "password-input", ...rest },
  ref
) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
        aria-pressed={show}
        className="absolute right-2 top-1/2 -translate-y-1/2 text-[var(--ag-text-muted)] hover:text-[var(--ag-text)] transition-colors p-1 rounded"
        data-testid={`${testId}-toggle`}
      >
        {show ? <EyeSlash size={16} weight="duotone" /> : <Eye size={16} weight="duotone" />}
      </button>
    </div>
  );
});

export default PasswordInput;
